class ProductCompareChroxel {
  constructor(slider) {
    this.slider = slider;
    this.handle = slider.querySelector('.product-compare-chroxel__handle');
    this.isDragging = false;

    slider._compareInstance = this;

    this.setPosition(50);

    this.handle.addEventListener('mousedown', this.onPointerDown.bind(this));
    this.handle.addEventListener('touchstart', this.onPointerDown.bind(this), { passive: true });
    this.handle.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  setPosition(percent) {
    const clamped = Math.max(0, Math.min(100, percent));
    this.slider.style.setProperty('--position', clamped + '%');
    this.handle.setAttribute('aria-valuenow', String(Math.round(clamped)));
  }

  getPercentFromEvent(event) {
    const rect = this.slider.getBoundingClientRect();
    const clientX = event.touches ? event.touches[0].clientX : event.clientX;
    const x = clientX - rect.left;
    return (x / rect.width) * 100;
  }

  onPointerDown(event) {
    if (event.type === 'mousedown' && event.button !== 0) return;
    this.isDragging = true;
    event.preventDefault();
  }

  onPointerMove(event) {
    if (!this.isDragging) return;
    this.setPosition(this.getPercentFromEvent(event));
  }

  onPointerUp() {
    this.isDragging = false;
  }

  onKeyDown(event) {
    const step = event.shiftKey ? 10 : 2;
    const current = parseInt(this.handle.getAttribute('aria-valuenow') || '50', 10);

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.setPosition(current - step);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.setPosition(current + step);
    } else if (event.key === 'Home') {
      event.preventDefault();
      this.setPosition(0);
    } else if (event.key === 'End') {
      event.preventDefault();
      this.setPosition(100);
    }
  }
}

function onPointerMove(event) {
  document.querySelectorAll('.product-compare-chroxel__slider').forEach((slider) => {
    const instance = slider._compareInstance;
    if (instance && instance.isDragging) {
      instance.onPointerMove(event);
    }
  });
}

function onPointerUp() {
  document.querySelectorAll('.product-compare-chroxel__slider').forEach((slider) => {
    if (slider._compareInstance) {
      slider._compareInstance.onPointerUp();
    }
  });
}

function initProductCompareChroxel() {
  document.querySelectorAll('.product-compare-chroxel__slider').forEach((slider) => {
    new ProductCompareChroxel(slider);
  });

  document.addEventListener('mousemove', onPointerMove);
  document.addEventListener('touchmove', onPointerMove, { passive: true });
  document.addEventListener('mouseup', onPointerUp);
  document.addEventListener('touchend', onPointerUp);
  document.addEventListener('dragstart', (e) => {
    if (e.target.closest('.product-compare-chroxel__slider')) {
      e.preventDefault();
    }
  });
}

// El script puede llegar despues de DOMContentLoaded (se carga en diferido cuando
// la seccion se acerca a pantalla), asi que hay que inicializar de una en ese caso.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCompareChroxel);
} else {
  initProductCompareChroxel();
}
